import AtecProductsAPI from '../../api/atecProducts';

const normalizeProduct = item => ({
  id: item.Prod_Codigo ?? item.codigo ?? item.id ?? item.code,
  name: item.Prod_Descricao ?? item.nome ?? item.name ?? item.descricao ?? '',
  sku: String(item.Prod_Codigo ?? item.codigo ?? item.id ?? ''),
  ean: String(item.Prod_CodBarra ?? item.ean ?? ''),
  price: Number(item.Prod_PrecoVenda ?? item.preco ?? item.price ?? item.vlrUnitario ?? 0),
  promoPrices: [],
  availablePrices: null,
  stock: Number(item.Prod_EstoqueAtual ?? item.estoque ?? item.stock ?? item.saldo ?? 0),
  brand: null,
  category: null,
  raw: item,
});

const buildAvailablePrices = price => {
  if (!price || price <= 0) return [];
  return [{ price: Math.round(price * 100) / 100, label: 'Tabela' }];
};

const normalizeProducts = rawItems =>
  (rawItems || []).map(item => {
    const normalized = normalizeProduct(item);
    return {
      ...normalized,
      availablePrices: buildAvailablePrices(normalized.price),
    };
  });

export const state = {
  items: [],
  pagination: { page: 1, limit: 40, count: 0 },
  uiFlags: { isFetching: false },
  error: null,
};

export const getters = {
  allProducts: $state => $state.items,
  productsPagination: $state => $state.pagination,
  productsUIFlags: $state => $state.uiFlags,
};

export const actions = {
  fetch: async ({ commit }, { q, limit = 40, page = 1 } = {}) => {
    commit('SET_UI_FLAG', { isFetching: true });
    commit('SET_ERROR', null);
    try {
      const res = await AtecProductsAPI.search({ q, limit, page });
      const payload = res.data || {};
      const rawItems = payload.items || payload.data || [];
      const pagination = payload.pagination || {
        page,
        limit,
        count: rawItems.length,
      };
      commit('SET_ITEMS', normalizeProducts(rawItems));
      commit('SET_PAGINATION', pagination);
    } catch (e) {
      commit('SET_ITEMS', []);
      commit('SET_PAGINATION', { page: 1, limit: 40, count: 0 });
      commit('SET_ERROR', e?.response?.data || { message: e.message });
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },
};

export const mutations = {
  SET_ITEMS($state, items) {
    $state.items = items;
  },
  SET_PAGINATION($state, pagination) {
    $state.pagination = pagination;
  },
  SET_UI_FLAG($state, uiFlag) {
    $state.uiFlags = { ...$state.uiFlags, ...uiFlag };
  },
  SET_ERROR($state, error) {
    $state.error = error;
  },
};

export default { namespaced: true, state, getters, actions, mutations };
